import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetUserProgramInstituteCoursesRequestObjectSchema,
  GetUserProgramInstituteCoursesRequestObjectType,
  GetUserProgramInstituteCoursesResponseSchema,
  GetUserProgramInstituteCoursesResponseType
} from '../../../services/PaymentServices/APIService/types';

import usePaymentServices from '../usePaymentServices';

interface UseGetUserProgramInstituteCoursesApiInterface {
  getUserProgramInstituteCoursesApi: UseMutateAsyncFunction<
    GetUserProgramInstituteCoursesResponseType,
    Error,
    GetUserProgramInstituteCoursesRequestObjectType
  >;
  error: string | null;
  status: MutationStatus;
}

const useGetUserProgramInstituteCoursesApi =
  (): UseGetUserProgramInstituteCoursesApiInterface => {
  const { paymentServices } = usePaymentServices();

  const getUserProgramInstituteCourses = (
    requestObject: GetUserProgramInstituteCoursesRequestObjectType
  ) => {
    try {
      GetUserProgramInstituteCoursesRequestObjectSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return paymentServices
      .getUserProgramInstituteCourses(requestObject)
      .then((response) => {
        try {
          GetUserProgramInstituteCoursesResponseSchema.parse(response ?? {});
        } catch (error) {
          console.error('Invalid response object:', error);
          throw error;
        }
        return response;
      });
  };

  const { mutateAsync, error, status } = useMutation(
    getUserProgramInstituteCourses,
    {
      mutationKey: ['getUserProgramInstituteCoursesApi']
    }
  );

  return {
    getUserProgramInstituteCoursesApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : null,
    status
  };
};

export { useGetUserProgramInstituteCoursesApi };
